/* eslint-disable react/no-unescaped-entities */
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useTable, useExpanded } from 'react-table';
import ReactTableRender from '../../../../../Components/ReactTable/ReactTableRender';
import { ThematicAreaBadge } from '../../../../../Components/ThematicAreaBadge';

function EventsReportTable({ loading, eventsData }) {
  const columns = useMemo(
    () => [
      {
        Header: <FormattedMessage id="sn" />,

        accessor: 'sequenceId'
      },
      {
        Header: <FormattedMessage id="province" />,
        accessor: 'province'
      },
      {
        Header: <FormattedMessage id="output_number" />,

        accessor: 'output_number'
      },
      {
        Header: <FormattedMessage id="date" />,

        accessor: 'date',
        Cell: ({ row: { original } }) => {
          return (
            <span className="small">
              {original.startDate} - {original.endDate}
            </span>
          );
        }
      },
      {
        Header: <FormattedMessage id="title" />,
        width: '250px',
        accessor: 'title'
      },
      {
        Header: <FormattedMessage id="thematic_area" />,

        width: '300px',
        accessor: 'thematic_areas',
        Cell: ({ row, cell: { value } }) => (
          <span className="d-flex align-items-center flex-wrap">
            {Boolean(value) && (
              <>
                {value.length > 3 ? (
                  <span className="small text-secondary" {...row.getToggleRowExpandedProps()}>
                    {row.isExpanded ? (
                      <div>
                        <span>👇</span>
                        <div>
                          {value.map((target, index) => (
                            <ThematicAreaBadge key={index}>{target}</ThematicAreaBadge>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div>
                        {Array.isArray(value) &&
                          value
                            ?.slice(0, 3)
                            ?.map((target, index) => (
                              <ThematicAreaBadge key={index}>{target}</ThematicAreaBadge>
                            ))}
                        +{value.length - 3} more 👉
                      </div>
                    )}
                  </span>
                ) : (
                  <span className="small text-secondary" {...row.getToggleRowExpandedProps()}>
                    <div>
                      <div>
                        {value.map((target, index) => (
                          <ThematicAreaBadge key={index}>{target}</ThematicAreaBadge>
                        ))}
                      </div>
                    </div>
                  </span>
                )}
              </>
            )}
          </span>
        )
      },
      // {
      //   Header: <FormattedMessage id="targeted_province" />,

      //   accessor: 'targeted_location'
      // },
      {
        Header: <FormattedMessage id="targeted_for" />,

        accessor: 'targeted_sector',
        width: '300px',
        Cell: ({ cell: { value } }) => (
          <div>
            {value.split(',').map((val) => (
              <div className="mb-3" key={val}>
                {val}
              </div>
            ))}
          </div>
        )
      },
      {
        Header: <FormattedMessage id="event.organized_by" />,

        accessor: 'organized_by',
        Cell: ({ cell: { value } }) => (
          <div>
            {value.split(',').map((val) => (
              <div key={val}>{val}</div>
            ))}
          </div>
        )
      },
      {
        Header: <FormattedMessage id="total_benificiaries" />,
        accessor: 'total_benificiaries'
      },
      {
        id: 'attended_participant_col',
        Header: <FormattedMessage id="participants_details" />,
        className: 'text-center',
        columns: [
          {
            Header: <FormattedMessage id="male" />,

            accessor: 'en_parti_male'
          },
          {
            Header: <FormattedMessage id="female" />,

            accessor: 'en_parti_female'
          },
          {
            Header: <FormattedMessage id="gender_minorities" />,
            accessor: 'en_parti_other'
          }
        ]
      },
      {
        id: 'participants_ethnicity_col',
        Header: <FormattedMessage id="participants_ethinicity" />,
        className: 'text-center',
        columns: [
          {
            id: 'brahmin_chhetri_col',
            Header: ' ',
            columns: [
              {
                Header: <FormattedMessage id="brahmin_chhetri" />,

                accessor: 'brahmin_chhetri'
              }
            ]
          },
          {
            id: 'aadhibasi_janajati_col',
            Header: <FormattedMessage id="aadhibasi_janajati" />,
            className: 'text-center',
            columns: [
              {
                Header: <FormattedMessage id="hill" />,

                accessor: 'aadhibasi_hill'
              },
              {
                Header: <FormattedMessage id="terai" />,

                accessor: 'aadhibasi_terai'
              }
            ]
          },
          {
            id: 'dalit_col',
            Header: <FormattedMessage id="dalit" />,
            className: 'text-center',
            columns: [
              {
                Header: <FormattedMessage id="hill" />,

                accessor: 'dalit_hill'
              },
              {
                Header: <FormattedMessage id="terai" />,

                accessor: 'dalit_terai'
              }
            ]
          },
          {
            id: 'madhesi_col',
            Header: ' ',
            columns: [
              {
                Header: <FormattedMessage id="madhesi" />,

                accessor: 'madhesi'
              }
            ]
          },
          {
            id: 'muslim_col',
            Header: ' ',
            columns: [
              {
                Header: <FormattedMessage id="muslim" />,

                accessor: 'muslim'
              }
            ]
          },
          {
            id: 'others_eth_col',
            Header: ' ',
            columns: [
              {
                Header: <FormattedMessage id="others" />,
                width: '3%',

                accessor: 'others_eth'
              }
            ]
          }
        ]
      },
      {
        Header: <FormattedMessage id="disability" />,

        accessor: 'disability'
      },
      {
        Header: <FormattedMessage id="total_resource_person" />,
        accessor: 'total_resource_person',
        Cell: ({ row: { original } }) => (
          <div>
            <div>
              <FormattedMessage id="total" />: {original.en_resor_total}
            </div>
            <div>
              <FormattedMessage id="male" />: {original.en_resor_male}
            </div>
            <div>
              <FormattedMessage id="female" />: {original.en_resor_female}
            </div>
            <div>
              <FormattedMessage id="other" />: {original.en_resor_other}
            </div>
          </div>
        )
      },
      {
        Header: <FormattedMessage id="estimated_vs_actual_budget" />,
        accessor: 'estimated_vs_actual_budget'
      },
      {
        Header: <FormattedMessage id="status" />,
        accessor: 'status'
      }
    ],
    []
  );

  const data = useMemo(() => {
    let count = 1;
    return eventsData.map((result) => {
      return {
        sequenceId: count++,
        province: result.province === '' ? 'संघिय' : result.province,
        actual_budget: result.actual_budget,
        estimated_budget: result.estimated_budget,
        estimated_actual_budget: result.estimated_actual_budget,
        expected_participant: result.expected_participant,
        output_number: result.output_number,
        program_type: result.program_type,
        organized_by: result.organized_by,
        total_benificiaries: result.participant_details.total,
        status: result.status,
        targeted_sector: result.targeted_sector,
        total_days: result.total_days,
        title: result.title,
        startDate: result.event_start_date,
        endDate: result.event_end_date,
        thematic_areas: (result.thematic_areas || '').split(','),
        event_location: result.event_location,
        en_parti_male: result.participant_details.male,
        en_parti_female: result.participant_details.female,
        en_parti_other: result.participant_details.other,
        brahmin_chhetri: result.participant_details['brahmin_chhetri'],
        aadhibasi_hill: result.participant_details['aadhibasi_hill'],
        aadhibasi_terai: result.participant_details['aadhibasi_terai'],
        dalit_hill: result.participant_details['dalit_hill'],
        dalit_terai: result.participant_details['dalit_terai'],
        madhesi: result.participant_details['madhesi'],
        muslim: result.participant_details['muslim'],
        others_eth: result.participant_details.others,
        en_resor_male: result.resource_person_details.male,
        en_resor_female: result.resource_person_details.female,
        en_resor_other: result.resource_person_details.other,
        en_resor_samuha: result.resource_person_details.samuha,
        en_resor_total: result.resource_person_details.total,
        disability: result.disability,
        estimated_vs_actual_budget: result.estimated_actual_budget
      };
    });
  }, [eventsData]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, visibleColumns } =
    useTable(
      {
        columns,
        data
      },
      useExpanded
    );

  return (
    <div>
      <ReactTableRender
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        getTableBodyProps={getTableBodyProps}
        page={rows}
        prepareRow={prepareRow}
        visibleColumns={visibleColumns}
        pagination={false}
        loading={loading}
        maxContent={true}
        noFilters={true}
      />
    </div>
  );
}

export default EventsReportTable;
